import React from 'react';
import { CheckCheckIcon } from 'lucide-react';
import { InlineCta } from './InlineCta';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/offer';
export function Testimonials() {
  return <section className="bg-ivory px-5 py-14" data-id="element-258" data-mp="3fxb3mkw0pud8">
      <SectionHeading eyebrow="Testimonianze" title="Cosa dicono" accent="gli insegnanti" data-id="element-259" data-mp="3azjdnwexoibo" />
      <div className="mt-9 space-y-4" data-id="element-260" data-mp="36z95cd3o5ftn">
        {testimonials.map((t, i) => <Reveal key={t.name} delay={i * 0.05} data-id="element-261" data-mp="32063t2mwdrqf" data-mpi={i}>
            <figure className="overflow-hidden rounded-2xl border border-ivory-line shadow-soft" data-id="element-262" data-mp="31ybhpkzw3tkr">
              <figcaption className="flex items-center gap-3 bg-espresso px-4 py-2.5" data-id="element-263" data-mp="2x1bgpohwdh0i">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-wood font-display text-base text-espresso" data-id="element-264" data-mp="2s3079evil8it">
                  {t.name.charAt(0)}
                </span>
                <span className="leading-tight" data-id="element-265" data-mp="qbn7f48elqtm">
                  <span className="block text-sm font-semibold text-ivory" data-id="element-266" data-mp="h5y8oeopdd3m">{t.name}</span>
                  <span className="block text-xs text-sand" data-id="element-267" data-mp="h8awv9l20jp4">{t.city}</span>
                </span>
              </figcaption>
              <div className="bg-ivory-2 p-3.5" data-id="element-268" data-mp="780mrxubfse6">
                <div className="ml-auto max-w-[92%] rounded-xl rounded-tr-sm bg-chat px-3.5 pb-1.5 pt-2.5 shadow-sm" data-id="element-269" data-mp="79lezgt5qz8v">
                  <blockquote className="text-[15px] leading-relaxed text-ink" data-id="element-270" data-mp="c8oll5osddiy">{t.text}</blockquote>
                  <div className="mt-1 flex items-center justify-end gap-1 text-[11px] text-ink-muted" data-id="element-271" data-mp="zysbybcyrgs0">
                    <span data-id="element-272" data-mp="14xddce3yc6i1">{t.time}</span>
                    <CheckCheckIcon className="h-3.5 w-3.5 text-[#53BDEB]" aria-label="Letto" data-id="element-273" data-mp="q7ef6bcecv2k" />
                  </div>
                </div>
              </div>
            </figure>
          </Reveal>)}
      </div>
      <InlineCta label="Lo voglio anch’io" data-id="element-274" data-mp="1iuij0czr73cr" />
    </section>;
}